<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="已缴导入" name="paid_export">
          <div>
            <div class="search-wrap" style="flex-direction: column">

              <div style="display: flex;flex-direction: row">
                <UploadFileSysc :host-url="host_url" :upload-url="host_url+'/admin/HouseCharge/uploadFile'" v-model="excel_file">
<!--                  <div style="width: 20px"></div>-->
                  <el-button size="mini" v-if="excel_file" type="primary" @click="showExcel">预览</el-button>
<!--                  <div style="width: 20px"></div>-->
                  <el-button size="mini" v-if="excel_list&&excel_list.length&&excel_list_error_num===0" type="primary" @click="importExcel">导入</el-button>
                  <el-button size="mini" v-if="excel_list&&excel_list.length" type="warning" @click="cleanImportExcel">取消</el-button>
                </UploadFileSysc>
              </div>
              <div style="display: flex;flex-direction: row;margin-top: 20px;">
                <div>
                  订单条数： <span style="color: #038dce">{{excel_list_num}}</span> 条
                </div>
                <div style="margin-left: 50px">
                  异常数： <span style="color: #ff3d00">{{excel_list_error_num}}</span> 条
                </div>
                <div style="margin-left: 50px">
                  应缴总金额： <span style="color: #038dce">{{excel_list_charge}}</span> 元
                </div>
                <div style="margin-left: 50px">
                  违约金欠费总金额： <span style="color: #038dce">{{excel_list_delaySum}}</span> 元
                </div>
                <div style="margin-left: 50px">
                  减免金额总金额： <span style="color: #038dce">{{excel_list_discount}}</span> 元
                </div>
                <div style="margin-left: 50px">
                  违约金总金额： <span style="color: #038dce">{{excel_list_delayDiscount}}</span> 元
                </div>
                <div style="margin-left: 50px">
                  缴款总金额： <span style="color: #038dce">{{excel_list_PaidChargeSum}}</span> 元
                </div>
              </div>
            </div>
            <div class="table-wrap">
              <el-table v-if="excel_list&&excel_list.length" v-loading="loading" :data="excel_list" :height="__TABLE_HEIGHT__" @selection-change="handleSelectionChange">
                <el-table-column
                  type="index"
                  width="50">
                </el-table-column>
                <el-table-column prop="bill_type" label="是否异常" align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="(scope.row.charge-scope.row.discount-scope.row.delayDiscount)>=0" size="mini" type="success" effect="dark">正常</el-tag>
                    <el-tag v-else size="mini" type="danger" effect="dark">异常</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="house_name" label="房产" align="center" width="200"></el-table-column>
                <el-table-column prop="xsc_Amount" label="面积" align="center" width="100"></el-table-column>
                <el-table-column prop="charge_user" label="收费对象" align="center" width="80"></el-table-column>
                <el-table-column prop="charge_name" label="收费项目" align="center" width="120"></el-table-column>
                <el-table-column prop="charge_name2" label="收费标准" align="center" width="120"></el-table-column>
                <el-table-column prop="charge" label="本期欠费" align="center" width="100"></el-table-column>
                <el-table-column prop="delaySum" label="违约金欠费" align="center" width="100"></el-table-column>
                <el-table-column prop="discount" label="减免金额" align="center" width="100"></el-table-column>
                <el-table-column prop="discount_type" label="减免类型" align="center" width="100"></el-table-column>
                <el-table-column prop="delayDiscount" label="违约金" align="center" width="100"></el-table-column>
                <el-table-column prop="ymt" label="应收日期" align="center" width="120"></el-table-column>
                <el-table-column prop="start_end_time" label="计费周期" align="center" width="180"></el-table-column>
                <el-table-column prop="payment_id" label="结算方式" align="center" width="100"></el-table-column>
                <el-table-column prop="should_charge_date" label="缴款日期" align="center" width="100"></el-table-column>
                <el-table-column prop="PaidChargeSum" label="缴款金额" align="center" width="100"></el-table-column>
                <el-table-column prop="xsc_bill_no" label="发票号码" align="center" width="100"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center" width="100"></el-table-column>
                <el-table-column prop="id" label="系统编号" align="center" width="100"></el-table-column>
                <el-table-column prop="bill_type" label="票据类型" align="center" width="100"></el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="模板下载" name="paid_import">
          <div style="width: 500px">
            <el-form :model="dow_form" :rules="dow_rules" ref="dow_form" label-width="100px" size="mini" style="margin-right: 50px;">
              <el-form-item label="房产" prop="project_house_id">
                <el-input class="form-input" placeholder="点击左侧房产" readonly v-model="dow_form.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="客户类型" prop="user_type">
                <el-select v-model="dow_form.user_type" placeholder="选择客户类型" clearable>
                  <el-option
                    v-for="item in [
                      {name:'个人客户',val:1},
                      {name:'开发商',val:2},
                    ]"
                    :key="item.val"
                    :label="item.name"
                    :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收费项目" prop="chargeItem_name_id">
                <el-select v-model="dow_form.chargeItem_name_id" placeholder="选择收费项" clearable>
                  <el-option
                    v-for="item in house_charge_item_list"
                    :key="item.id"
                    :label="item.chargeItem_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收费标准" prop="pindex_house_charge_id">
                <el-select v-model="dow_form.pindex_house_charge_id" placeholder="选择收费标准" clearable>
                  <el-option
                    v-for="item in house_charge_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="计费周期" prop="start_end_time">
                <el-date-picker
                  size="mini"
                  v-model="dow_form.start_end_time"
                  unlink-panels
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="应收日期" prop="start_end_time2">
                <!--                <el-date-picker-->
                <!--                  size="mini"-->
                <!--                  v-model="dow_form.date_time"-->
                <!--                  type="date"-->
                <!--                  format="yyyy-MM-dd"-->
                <!--                  value-format="yyyy-MM-dd"-->
                <!--                  placeholder="选择日期">-->
                <!--                </el-date-picker>-->
                <el-date-picker
                  size="mini"
                  v-model="dow_form.start_end_time2"
                  unlink-panels
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="缴费对象" prop="payment_object">
                <el-checkbox-group v-model="dow_form.payment_object">
                  <el-checkbox v-for="item in [
                      {name:'业主',val:1},
                      {name:'租户',val:2},
                      {name:'住户',val:3},
                      {name:'开发商',val:5},
                      {name:'其它',val:9},
                    ]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
                </el-checkbox-group>
<!--                <el-select v-model="dow_form.payment_object" multiple placeholder="选择缴费对象" clearable>-->
<!--                  <el-option-->
<!--                    v-for="item in [-->
<!--                      {name:'业主',val:1},-->
<!--                      {name:'租户',val:2},-->
<!--                      {name:'住户',val:3},-->
<!--                      {name:'开发商',val:5},-->
<!--                      {name:'其它',val:9},-->
<!--                    ]"-->
<!--                    :key="item.name"-->
<!--                    :label="item.name"-->
<!--                    :value="item.val">-->
<!--                  </el-option>-->
<!--                </el-select>-->
              </el-form-item>
              <el-form-item label="" prop="title">
                <el-button size="mini" type="primary" @click="dowExcel()" style="margin-right: 5px;">下载模板</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import UploadFileSysc from "./components/UploadFileSysc";
import ErpTreeStatus from "../Common/erp-tree-status";
import CommonHelp from "../Contract/common/CommonHelp";
export default {
  name: "PaidExcel",
  components: {ErpTreeStatus, UploadFileSysc},
  data () {
    return {
      host_url:"",
      loading: false,
      activeName:"paid_export",
      where:{
        name:""
      },
      excel_list:[],
      dialogVisible:false,
      dow_form:{
        name:"",
        project_house_id:"",
        user_type:"",
        pindex_house_charge_id:"",
        chargeItem_name_id:"",
        start_end_time:"",
        start_end_time2:"",
        payment_object:""
      },
      dow_rules: {
        project_house_id: [
          { required: true, message: '请选择项目', trigger: 'blur' },
        ],
        chargeItem_name_id: [
          { required: true, message: '请选择收费项目', trigger: 'change' },
        ],
        pindex_house_charge_id: [
          { required: true, message: '选择收费标准', trigger: 'change' },
        ],
        date_time: [
          { required: true, message: '选择应收日期', trigger: 'change' },
        ],
        start_end_time: [
          { required: true, message: '选择计费周期', trigger: 'change' },
        ],
        start_end_time2: [
          { required: true, message: '选择计费周期', trigger: 'change' },
        ],

      },
      form:{
        name:"",
        xsc_code:"",
        status:"",
        invoicing_limit:"",
        refund_audit:"",
        sort:"",
        expense_category:"",
        bill_type:"",
        files:"",
        financial_code:"",
        financial_code_name:"",
        remarks:"",
      },
      house_charge_list:[],
      house_charge_item_list:[],
      excel_file:""
    }
  },
  created() {
    this.host_url=__HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getHouseChargeItemList()
  },
  activated() {
    // this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "dow_form.pindex_house_charge_id":function (n) {
      this.getHouseChargeList();
    },
    "dow_form.project_house_id":function (n) {
      this.getHouseChargeList();
    },

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
    excel_list_num(){
      return this.excel_list.length
    },
    excel_list_charge(){
      return this.excel_list.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.charge*1);
        return total;
      }, 0)
    },
    excel_list_error_num(){
      return this.excel_list.filter(ret=>{
        return (ret.charge-ret.discount-ret.delayDiscount)<0
      }).length
    },
    excel_list_delaySum(){
      return this.excel_list.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.delaySum*1);
        return total;
      }, 0)
    },
    excel_list_discount(){
      return this.excel_list.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.discount*1);
        return total;
      }, 0)
    },
    excel_list_delayDiscount(){
      return this.excel_list.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.delayDiscount*1);
        return total;
      }, 0)
    },
    excel_list_PaidChargeSum(){
      return this.excel_list.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.PaidChargeSum*1);
        return total;
      }, 0)
    }
  },
  methods: {
    showExcel() {
      var that=this;
      that.loading=true;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      ERP.postRequest({
        url:"admin/PaidExcel/paidImportExcelShow",
        data:{
          file:that.excel_file,
        }
      },res=>{
        if(res.code) {
          that.excel_list=res.data
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
        that.loading=false;
      })
    },
    importExcel() {
      var that=this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定导入Excel表单数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        ERP.postRequest({
          url:"admin/PaidExcel/paidImportExcel",
          data:{
            file:that.excel_file,
          }
        },res=>{
          if(res.code) {
            that.$message.success('Excel表单导入成功');
            that.excel_list=[];
            that.excel_file=""
          }else {
            that.$message.error('Excel表单导入失败');
          }
          that.loading=false;
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    cleanImportExcel(){
      this.excel_file=""
      this.excel_list=[]
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data);
      this.dow_form.project_house_id = data.tree[0].pindex_id;
      this.dow_form.name=tree_str;
    },
    getHouseChargeItemList(){
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.dow_form.project_house_id&&(where.pindex_id=this.dow_form.project_house_id);
      this.dow_form.chargeItem_name_id&&(where.chargeItem_name_id=this.dow_form.chargeItem_name_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    dowExcel(){
      var that=this;
      this.$refs.dow_form.validate((valid) => {
        if (valid) {
          let where=reObject(this.dow_form);
          where.start_end_time=where.start_end_time.join(',')
          where.start_end_time2=where.start_end_time2.join(',')
          where.payment_object&&(where.payment_object=where.payment_object.join(','))
          ERP.postRequest({
            url:"admin/PaidExcel/paidExportExcel",
            data:where
          },ret=>{
            if(ret.code){
              window.open(__HTTP__.defaults.baseURL +ret.data)
            }
          })
        } else {
          return false;
        }
      });

    }
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>

.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/PaidExcel.vue